import React, { Suspense, 
  // useContext,
   useState } from "react";
import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
// import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
// import { buildQueryString } from "utils/queryHelpers";
// import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { useCustomer } from "contexts/v1/masterData/CustomerContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";
import { ProductCreateProvider } from "contexts/v1/masterData/ProductCreateContext";

const CustomersPage = () => {
  const { customers, refetch, Pagination } = useCustomer();
  console.log("CustomersPage", customers);
  const [search, setSearch] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);

  // const queryString = buildQueryString({
  //   search: search || "",
  //   page: currentPage,
  //   limit: LIMIT_DATA_PER_PAGE,
  // });

  // useFetchData(`/customer${queryString}`, "customers");
  // const { deleteData } = useDeleteData("/customer", "customers", queryString);

  // const { state } = useContext(AppContext);
  // const { customers } = state;

  // Function to generate random data
  // Function to generate random data
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/customer/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Customer deleteing");
          refetch();
        }
      }
    });
  };

  const {  handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Customer",
      <ProductCreateProvider>
        <CreatePage
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Customer created successfully");
            handleSuccessToast(true, "Customer createing");
            refetch();
          }}
          onError={handleError}
        />
      </ProductCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Customer",
      <ProductCreateProvider>
        <CreatePage
          initialData={data}
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Customer updated successfully");
            handleSuccessToast(true, "Customer updateding");
            refetch();
          }}
          onError={handleError}
        />
      </ProductCreateProvider>
    );
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  // const totalPages = customers.pagination?.last_page || 1;

  // const Pagination = usePaginationWithComponent({
  //   totalPages,
  //   currentPage,
  //   onPageChange: setCurrentPage,
  //   visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  // });

  if (customers.loading) return <FullLoader />;
  if (customers.error) return <Suspense error={customers.error} />;

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container vh-100">
          <h1>Customers</h1>

          <div className="search-container mb-3">
            {/* Search input */}
            <SearchInput handleSearch={handleSearch} defaultValue={search} />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          {/* Table */}
          <div className="table">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Nationality/Hotel</th>
                  <th>Mark</th>
                  {/* <th>Labels</th> */}
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {customers.data.length > 0 && (
                <tbody>
                  {customers.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>{data.email}</td>
                        <td>{data.phone}</td>
                        <td>{data.nationality}</td>
                        <td>
                          <ExpandableText
                            text={data.mark ?? "N/A"}
                            maxLength={30}
                          />
                        </td>

                        {/* Set maxLength */}
                        {/* <td>{data.labels.map((data) => (
                                                    <span key={data.id} className="badge badge-outline text-cyan me-1">{data.name}</span>
                                                ))}</td> */}
                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          {/* <div className="mt-4">{Pagination}</div> */}
          <div className="mt-4">{customers.data.length > 0 && Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default CustomersPage;

const ExpandableText = ({ text = "", maxLength = 20 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Fungsi untuk toggle teks (expand atau collapse)
  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  // Jika teks lebih panjang dari `maxLength`, tampilkan versi pendek
  const displayText =
    isExpanded || text.length <= maxLength
      ? text
      : text.slice(0, maxLength) + "...";

  return (
    <span>
      {displayText}
      {text.length > maxLength && (
        <button
          onClick={toggleExpanded}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            cursor: "pointer",
            marginLeft: "5px",
            padding: 0,
          }}
        >
          {isExpanded ? "Show less" : "Read more"}
        </button>
      )}
    </span>
  );
};

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useCustomer();
  const [search, setSearch] = useState(filterOptions.search || "");

  // Fungsi untuk menangani input pencarian
  // const handleSearchInput = (e) => {
  //   if (e.key === "Enter") {
  //     if (!search.trim()) {
  //       // Tampilkan toast untuk error
  //       Swal.fire({
  //         toast: true,
  //         position: "top-end",
  //         icon: "error",
  //         title: "Search input cannot be empty!",
  //         showConfirmButton: false,
  //         timer: 3000, // Toast akan otomatis hilang setelah 3 detik
  //         timerProgressBar: true,
  //       });
  //     } else {
  //       handleSearch(handleSearch);
  //     }
  //   }
  // };

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
        // onKeyDown={handleSearchInput} // Tangani event saat tombol ditekan
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
